module.exports = __webpack_public_path__ + "assets_app/img/key_8.27b8b34c.svg";